/**
 * ContextAwareNavbar - Automatically selects the right navbar based on subdomain/route
 * 
 * Usage:
 * - On app.domain.com or /admin, /seller, /buyer, /dashboard routes → Shows AppNavbar (RoleBasedNavbar)
 * - On www.domain.com or /, /about, /services, /contact routes → Shows MarketingNavbar (Navbar)
 */
import { useSubdomain } from '@/hooks/useSubdomain';
import { AppNavbar } from './AppNavbar';
import { MarketingNavbar } from './MarketingNavbar';

export const ContextAwareNavbar = () => {
  const { context } = useSubdomain();
  
  if (context === 'app') {
    return <AppNavbar />;
  }
  
  return <MarketingNavbar />;
};
